import { sharedMessages } from '@/shared-messages/shared.messages';

/**
 * Utility functions for handling gender-related operations
 */

/**
 * Converts gender enum values to human-readable labels
 * @param gender - The gender value from the character schema
 * @returns Human-readable gender label
 */
export const getGenderLabel = (gender: string): string => {
  return (
    sharedMessages.genderLabels[
      gender as keyof typeof sharedMessages.genderLabels
    ] || gender
  );
};
